import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { MuiThemeProvider } from '@material-ui/core/styles';
// import the Roboto Font used by the material-ui library
import 'typeface-roboto';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import theme from './theme';

import PrivateRoute from '../utils/routes/privateRoute';
import ViewerRoute from '../utils/routes/viewerRoute';
import AdminRoute from '../utils/routes/adminRoute';
import AlertRoute from '../utils/routes/alertRoute';
// Pages and components ------------------------------
import Notifier from './common/Notifier';
import Layout from './common/Layout';
import Home from './home/HomeContainer';
import Sessions from './sessions/SessionsContainer';
import Login from './auth/login/LoginContainer';
import Reset from './auth/reset/PswResetContainer';
import Redirect from './auth/Redirect';
import NewPassword from './auth/NewPassword';
import SetPasswordResponse from './auth/alertDashboard/SetPasswordResponse';
import Management from './management/ManagementContainer';
import Patient from './patient/PatientContainer';
import Alerts from './alert/AlertContainer';
import PatientsOnboarding from './onboard/patients/PatientsContainer';
import Disclaimer from './disclaimer/DisclaimerComponent';
import Stream from './stream/StreamContainer';
import LiveCalls from './live-calls/LiveCallsContainer';
import FileDrops from './file-drops/FileDropsContainer';
import Upload from './upload/UploadContainer';
// ---------------------------------------------------

class App extends Component {
  render() {
    const { role, isLoggedIn } = this.props;
    return (
      <MuiThemeProvider theme={theme}>
        <Router>
          <div>
            <Switch>
              <Layout>
                {/* Add all your remaining routes here */}
                <AlertRoute
                  path="/alerts"
                  component={Alerts}
                  isLoggedIn={isLoggedIn}
                  role={role}
                />
                <AdminRoute
                  path="/staff"
                  component={Management}
                  isLoggedIn={isLoggedIn}
                  role={role}
                />
                <PrivateRoute
                  path="/stream"
                  component={Stream}
                  isLoggedIn={isLoggedIn}
                  role={role}
                />
                <PrivateRoute
                  path="/live-calls"
                  component={LiveCalls}
                  isLoggedIn={isLoggedIn}
                  role={role}
                />
                <PrivateRoute
                  path="/drops"
                  component={FileDrops}
                  isLoggedIn={isLoggedIn}
                  role={role}
                />
                <PrivateRoute
                  path="/disclaimer"
                  component={Disclaimer}
                  isLoggedIn={isLoggedIn}
                  role={role}
                />
                <ViewerRoute
                  exact
                  path="/sessions"
                  component={Sessions}
                  isLoggedIn={isLoggedIn}
                  role={role}
                />
                <ViewerRoute
                  exact
                  path="/home"
                  component={Home}
                  isLoggedIn={isLoggedIn}
                  role={role}
                />
                <PrivateRoute
                  exact
                  path="/patient/:userId"
                  component={Patient}
                  isLoggedIn={isLoggedIn}
                  role={role}
                />
                <PrivateRoute
                  exact
                  path="/onboard"
                  component={PatientsOnboarding}
                  isLoggedIn={isLoggedIn}
                  role={role}
                />
                <PrivateRoute
                  exact
                  path="/upload"
                  component={Upload}
                  isLoggedIn={isLoggedIn}
                  role={role}
                />

                <Route exact path="/" component={Login} />

                <Route
                  path="/__/auth/reset/setpasswordresponse"
                  component={SetPasswordResponse}
                />

                <Route
                  exact
                  path="/__/auth/reset/setpassword"
                  component={NewPassword}
                />

                <Route
                  exact
                  path="/__/auth/reset/2factauth"
                  component={Reset}
                />

                <Route
                  exact
                  path="/__/auth/reset/redirect"
                  component={Redirect}
                />
              </Layout>
            </Switch>
          </div>
        </Router>
        <Notifier />
      </MuiThemeProvider>
    );
  }
}

App.propTypes = {
  role: PropTypes.string, 
  isLoggedIn: PropTypes.bool
};

const mapStateToProps = state => {
  const { isLoggedIn } = state.login;
  const { role } = state.login.portalConfig;

  return {
    isLoggedIn,
    role
  };
};

export default connect(mapStateToProps, null)(App);
